import React from 'react';

export const EqAreaModal = {
  title: 'Area',
  body: (
    <div>
      <p>
        The State, Province or Prefecture where the earthquake effects were observed.
      </p>
    </div>
  ),
};
